import {
    Grid,
    Button,
    Typography,
    TextField,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormControl,
    Select,
    MenuItem,
    RadioGroup,
    Radio,
    InputAdornment,
} from "@mui/material";
import React from "react";
import { Sidebar } from "../../components/Sidebar";
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import { useNavigate } from "react-router-dom";

const Injury = () => {
    const navigate = useNavigate()
    return (
        <>
            <Sidebar>
                <Grid m={3}>
                    <Typography>Injury Report</Typography>
                    <Typography>&nbsp;</Typography>
                    <Grid container px={3} py={5} sx={{ backgroundColor: 'white', border: '2px solid #bdbdbd', borderRadius: 1 }}>
                        <Grid container className='d-flex justify-content-end '>
                            <Grid item md={8} sm={8} xs={12} sx={{ height: '100%' }}>
                                <Button variant="outlined" sx={{ color: 'black', border: '1px solid gray', padding: '15px 0', marginRight: '8px' }} size='small'> + </Button>
                                <TextField
                                    id="input-with-icon-textfield"

                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}

                                />
                                <Button variant="outlined" sx={{ color: 'black', border: '1px solid gray', padding: '15px 0', marginLeft: '8px' }}> <AutoAwesomeMotionIcon /> </Button>
                                <Button variant="outlined" sx={{ color: 'black', border: '1px solid gray', padding: '15px 0', marginLeft: '8px' }}> <DeleteIcon /> </Button>

                            </Grid>
                        </Grid>
                        <Grid container my={3} className='d-flex justify-content-center'>
                            <Grid item md={5} lg={5} xs={8} className='d-flex justify-content-between'>
                                <Typography variant="h4">Add Details</Typography>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Grid item>
                                <Typography>Name of Injured</Typography>
                            </Grid>
                            <Grid item>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox color="info" size="small" />} label="Child" />
                                </FormGroup>
                            </Grid>
                            <Grid item>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox color="info" size="small" />} label="Team Member" />
                                </FormGroup>
                            </Grid>
                            <Grid item>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox color="info" size="small" />} label="Parent" />
                                </FormGroup>
                            </Grid>
                            <Grid item>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox color="info" size="small" />} label="Student/Visitor" />
                                </FormGroup>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Grid item sm={3}>
                                <Typography>Name of Injured</Typography>
                            </Grid>
                            <Grid item sm={5}>
                                <FormControl size='small' sx={{ minWidth: 177 }}>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="Select/Enter"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='Select/Enter'>Select/Enter</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={4}>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox color="info" size="small" />} label="Same as Login" />
                                </FormGroup>
                            </Grid>
                        </Grid>

                        <Grid container mt={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item md={3}>
                                <Typography>Date/Time</Typography>
                            </Grid>
                            <Grid item md={3} >
                                <TextField type='date' size='small' sx={{ minWidth: 150 }} />
                            </Grid>
                            <Grid item sx={{ display: 'flex' }}>
                                <FormControl sx={{ minWidth: 110 }} size='small'>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="11"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='11'>11</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sx={{ display: 'flex' }}>
                                <FormControl sx={{ minWidth: 110 }} size='small'>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="00"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='00'>00</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sx={{ display: 'flex' }}>
                                <FormControl sx={{ minWidth: 110 }} size='small'>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="AM"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='AM'>AM</MenuItem>
                                        <MenuItem value="PM">PM</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item sm={3}>
                                <Typography>Team Member Incharge during the incident</Typography>
                            </Grid>
                            <Grid item sm={3}>
                                <FormControl sx={{ minWidth: 180 }} size='small' >
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="Select"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='Select'>Select</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item >
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox color="info" size="small" />} label="Same educator as above" />
                                </FormGroup>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Grid item md={6}>
                                <Typography>Was first aid provided</Typography>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="yes" control={<Radio size="small" color="info" />} label="Yes" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="no" control={<Radio size="small" color="info" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Grid item md={6}>
                                <Typography>Was further medical treatment provided? (eg:was ambulance/doctor on call?)</Typography>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"

                                    >
                                        <FormControlLabel value="yes" control={<Radio size="small" color="info" />} label="Yes" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="no" control={<Radio size="small" color="info" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Grid item md={6}>
                                <Typography>Serious Injury?</Typography>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"

                                    >
                                        <FormControlLabel value="yes" control={<Radio size="small" color="info" />} label="Yes" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="no" control={<Radio size="small" color="info" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Grid item md={6}>
                                <Typography>Head/facial</Typography>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="yes" control={<Radio size="small" color="info" />} label="Yes" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="no" control={<Radio size="small" color="info" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Grid item md={6}>
                                <Typography>Does regulatory authorities need to be notified ?</Typography>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="yes" control={<Radio size="small" color="info" />} label="Yes" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="no" control={<Radio size="small" color="info" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item color='red' md={4}>
                                <Typography>*Please enter this field*</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Grid item>
                                <Typography>Name of Injured person</Typography>
                            </Grid>
                            <Grid item >
                                <FormControl sx={{ minWidth: 130 }} size='small'>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="Dropdown"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='Dropdown'>Dropdown</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <Typography>Location-witness/Station</Typography>
                            </Grid>
                            <Grid item >
                                <FormControl sx={{ minWidth: 130 }} size='small'>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="Dropdown"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='Dropdown'>Dropdown</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item md={3}>
                                <Typography>Responsible person</Typography>
                            </Grid>
                            <Grid item md={3} ml={4}>
                                <FormControl sx={{ minWidth: 130 }} size='small'>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value="Dropdown"
                                    >
                                        <MenuItem value="">
                                        </MenuItem>
                                        <MenuItem value='Dropdown'>Dropdown</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item >
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox color="info" />} label="Me" />
                                </FormGroup>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item md={3}>
                                <img src="https://t3.ftcdn.net/jpg/02/38/00/56/360_F_238005627_QgvAPoIEet2f14EAZHt0CqAmyLCByqIE.jpg" alt="" />
                            </Grid>
                            <Grid item md={9}>
                                <TextField id="outlined-basic" label="Describe the story..." className="w-100" variant="outlined" size="large" multiline rows={6} style={{ backgroundColor: '#e0e0e0' }} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={2}>
                            <Grid item md={6}>
                                <Grid container rowSpacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Grid item sm={5}>
                                        <Typography>First aid provider</Typography>
                                    </Grid>
                                    <Grid item sm={7}>
                                        <FormControl sx={{ minWidth: 130 }} size='small' className="w-100">
                                            <Select
                                                labelId="demo-simple-select-helper-label"
                                                id="demo-simple-select-helper"
                                                value="Dropdown"
                                            >
                                                <MenuItem value="">
                                                </MenuItem>
                                                <MenuItem value='Dropdown'>Dropdown</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={5}>
                                        <Typography>First aid Location</Typography>
                                    </Grid>
                                    <Grid item sm={7}>
                                        <FormControl sx={{ minWidth: 130 }} size='small' className="w-100">
                                            <Select
                                                labelId="demo-simple-select-helper-label"
                                                id="demo-simple-select-helper"
                                                value="Dropdown"
                                            >
                                                <MenuItem value="">
                                                </MenuItem>
                                                <MenuItem value='Dropdown'>Dropdown</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={5}>
                                        <Typography>Medical Practioner name</Typography>
                                    </Grid>
                                    <Grid item sm={7}>
                                        <TextField id="outlined-basic" className="w-100" variant="outlined" size="small" />
                                    </Grid>
                                    <Grid item sm={5}>
                                        <Typography>Medical Practioner number</Typography>
                                    </Grid>
                                    <Grid item sm={7}>
                                        <TextField id="outlined-basic" className="w-100" variant="outlined" size="small" />
                                    </Grid>
                                    <Grid item sm={6}>
                                        <Typography>Should parent be notified</Typography>
                                    </Grid>
                                    <Grid item sm={3}>
                                        <FormControl>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel value="yes" control={<Radio size="small" color="info" />} label="Yes" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={3}>
                                        <FormControl>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel value="no" control={<Radio size="small" color="info" />} label="No" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={6} >
                                <TextField id="outlined-basic" label="Enter 4 Digit Pin" className="w-100" variant="outlined" multiline rows={2} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={4} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item md={12}>
                                <Typography>Responsible person name</Typography>
                            </Grid>
                            <Grid item md={3}>
                                <Typography>Root cause</Typography>
                            </Grid>
                            <Grid item sm={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                <TextField id="outlined-basic" label="Describe the story..." variant="outlined" multiline rows={2} sx={{ minWidth: 400 }} />
                                <MicIcon />
                            </Grid>
                            <Grid item mt={3}>
                                <Typography>Safety precautions</Typography>
                            </Grid>
                            <Grid item sm={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                <TextField id="outlined-basic" label="Describe the story..." variant="outlined" multiline rows={2} sx={{ minWidth: 400 }} />
                                <MicIcon />
                            </Grid>
                            <Grid item mt={3}>
                                <Typography>Recommendations</Typography>
                            </Grid>
                            <Grid item sm={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                <TextField id="outlined-basic" label="Describe the story..." variant="outlined" multiline rows={2} sx={{ minWidth: 400 }} />
                                <MicIcon />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} mt={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item md={6}>
                                <Typography>Parent notification status</Typography>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="emailsent" control={<Radio size="small" color="info" />} label="Email Sent" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="emailnotsent" control={<Radio size="small" color="info" />} label="Email Not Sent" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={6} mt={2}>
                                <Typography>Parent acknowledgement status</Typography>
                            </Grid>
                            <Grid item md={3} mt={2}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="acknw" control={<Radio size="small" color="info" />} label="Acknowledgement Received" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3} mt={2}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="acknwn" control={<Radio size="small" color="info" />} label="Acknowledgement Not Received" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={6} mt={2}>
                                <Typography>Should parent be notified</Typography>
                            </Grid>
                            <Grid item md={3} mt={2}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="yes" control={<Radio size="small" color="info" />} label="Yes" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={3} mt={2}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="no" control={<Radio size="small" color="info" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <Grid item mt={6} >
                                <Button sx={{ mx: 2 }} className="cancel_btn">Cancel</Button>
                                <Button className="btn_primary" onClick={() => navigate('/injurysummary')}>Next</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Sidebar>
        </>
    );
};
export default Injury;
